import React, { Suspense, useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { persistor, store } from "src/redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import ErrorBoundary from "src/components/ErrorBoundary";
import OmniChatIdentity from "src/components/OmniChatIdentity";
import "react-toastify/dist/ReactToastify.css";
import "./i18n";
import { Backdrop } from "@mui/material";
const TheContent = React.lazy(() => import("src/components/TheContent"));

const FullscreenSpin = () => (
  <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}>
    <div className="container_loader">
      <div className="clock"></div>
      <p style={{ marginTop: "7rem" }}>Loading...</p>
    </div>
  </Backdrop>
);

function App() {
  if (!window.env || !window.env.REACT_APP_NAME) {
    return <FullscreenSpin />;
  }

  return (
    <HelmetProvider>
      <Helmet>
        <title>
          {window.env.REACT_APP_NAME} -
          {window.env.REACT_APP_NAME === "BB98BET"
            ? " เว็บที่ดีที่สุดสุดยอดเว็บคาสิโนออนไลน์ บาคาร่า สล็อต"
            : window.env.REACT_APP_TITLE
              ? window.env.REACT_APP_TITLE
              : ""}
        </title>
        <meta
          name="description"
          content={
            window.env.REACT_APP_NAME === "BB98BET"
              ? `${window.env.REACT_APP_NAME} - คาสิโน ฝาก-ถอน 30 วินาที`
              : `${window.env.REACT_APP_NAME} - แทงหวย ตรวจหวย ผลหวย`
          }
        />
      </Helmet>

      <ErrorBoundary>
        <Provider store={store}>
          <PersistGate loading={<FullscreenSpin />} persistor={persistor}>
            <Suspense fallback={<FullscreenSpin />}>
              <OmniChatIdentity />
              <ToastContainer
                position="bottom-right"
                autoClose={3000}
                hideProgressBar={false}
                closeOnClick
                pauseOnHover
              />
              <TheContent />
            </Suspense>
          </PersistGate>
        </Provider>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
